export enum BackupMedium {
  SticKey = "SticKey",
  DiceKey = "DiceKey",
}